var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wrap',!_vm.$route.meta.hasNoHeader?'has-header':'']},[_c('page-header'),_c('router-view'),(_vm.$route.meta.hasFooter)?_c('page-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }